import React, { useEffect, useState } from 'react'
import { Development, DevelopmentMediacore, RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import { excludeIncludeDevelopments, getReverseOrder } from '@helpers/helper.developments'

interface ExternalProps {
  tag: string
}

interface ButtonFilter {
  name: string
  value: number
}

type CombinedProps = ExternalProps & RealEstateDataPageComponentData

const DICCIONARIO: any = {
  'VER TODOS': 1,
  'PRE-VENTA': 2,
  'EN POZO': 3,
  'EN CONSTRUCCIÓN': 4,
  TERMINADO: 5,
}

const Developments_1 = (props: CombinedProps) => {
  const { tag, global_data } = props
  const {
    title,
    align,
    paragraph,
    columns,
    alternativeButtons,
    excludeTag,
    includeTag,
    spanText,
    is_short,
    backgroundSecondary,
  } = props

  const devCard = spanText ? spanText : global_data.content?.cardsDevelopments?.type_id ?? '1'

  const [filter, setFilter] = useState('VER TODOS')
  const [buttons, setButtos] = useState<ButtonFilter[]>([])

  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(
    global_data.pageConfig.keys.tokko,
  )

  const [developments, setDevelopments] = useState<any>(allDevelopmentsData)

  const getStatusByDevelopments = () => {
    let status = [
      {
        name: 'VER TODOS',
        value: 0,
      },
    ]
    if (allDevelopmentsData && !isLoading) {
      for (const iterator of allDevelopmentsData) {
        if (
          !status.find(
            (s) =>
              s?.name?.toLowerCase() ===
              convertStatusIdToString(iterator?.construction_status.toString()).toLowerCase(),
          )
        ) {
          status.push({
            name: convertStatusIdToString(iterator.construction_status),
            value: status.length + 1,
          })
        }
      }
    }
    return status
  }

  const convertStatusIdToString = (statusId: number | string) => {
    switch (statusId.toString()) {
      case '1':
        return 'DESCONOCIDO'
      case '2':
        return 'REUNIENDO INVERSORES'
      case '3':
        return 'EN POZO'
      case '4':
        return 'EN CONSTRUCCIÓN'
      case '5':
        return 'DETENIDO'
      case '6':
        return 'TERMINADO'
      default:
        return statusId.toString().toUpperCase()
    }
  }

  useEffect(() => {
    if (allDevelopmentsData) {
      const devs = excludeIncludeDevelopments(allDevelopmentsData, includeTag!, excludeTag!)
      setDevelopments(devs)
    }
  }, [allDevelopmentsData])

  useEffect(() => {
    if (developments) {
      setButtos(getStatusByDevelopments())
    }
  }, [developments])

  const checkTag = (developments: Development[] | DevelopmentMediacore[]) => {
    //Function to check if this page has a tag
    const development_array = developments
    if (tag) {
      return development_array.filter(
        (element: { custom_tags: any[] }) =>
          element.custom_tags.find(
            (c_tag: { name: string }) => c_tag.name.replaceAll(' ', '-').toLowerCase() === tag,
          ) && !element.custom_tags.find((tag) => tag.name.toLowerCase() === 'portada'),
      )
    }
    if (filter.toLowerCase() === 'ver todos') {
      return development_array
    }
    return development_array.filter(
      (d) =>
        d.construction_status.toString().toLowerCase() === filter.toString().toLowerCase() ||
        convertStatusIdToString(d.construction_status.toString()).toLowerCase() ===
          filter.toString().toLowerCase(),
    ) // Nuevo por strings
    // return development_array.filter(
    //   element =>
    //     !element.custom_tags.find(tag => tag.name.toLowerCase() === "portada")
    // )
  }

  const Card = require(`@components/cardsDevelopments/${devCard}`)?.default

  return (
    <section
      className={
        'development-about p-y-config a ' +
        (align === 'center' ? ' text-center ' : '') +
        (!isLoading && (developments?.length === 0 || developments === undefined) ? 'd-none' : '') +
        (backgroundSecondary ? ' transparent-buttons' : '')
      }
    >
      <Container fluid>
        <Row className="row">
          <Col xs={12}>
            <h2 className="title">{title} </h2>
            {paragraph && <p className="mt-lg-5 mt-3 pb-lg-4">{paragraph}</p>}
          </Col>
        </Row>
      </Container>
      <div id="featured-devs">
        {!is_short && (
          <Container
            fluid
            className={'my-5 pb-lg-3'}
          >
            <div className={'d-flex flex-wrap justify-content-center '}>
              {isLoading ? (
                <>
                  {[1, 2, 3, 4].map((buttonA) => (
                    <button
                      key={buttonA}
                      className={'button-filter btn mb-2 mb-lg-0 skeleton '}
                    >
                      XXXXXXXX
                    </button>
                  ))}
                </>
              ) : (
                buttons
                  .sort((a, b) => DICCIONARIO[a.name] - DICCIONARIO[b.name])
                  .map(
                    (buttonA, index) => (
                      <button
                        key={index}
                        className={
                          'button-filter btn text-uppercase mb-2 mb-lg-0 ' +
                          (filter === buttonA.name ? ' active ' : '') +
                          (alternativeButtons ? ' btn-secondary' : ' ')
                        }
                        onClick={() => setFilter(buttonA.name)}
                      >
                        {buttonA.name}
                      </button>
                    ),
                    // )
                  )
              )}
            </div>
          </Container>
        )}
        {
          <Container fluid>
            <Row className="no-gutters mt-5 mt-lg-1 mb-lg-4">
              {!isLoading ? (
                checkTag(getReverseOrder(developments)!)?.length > 0 ? (
                  checkTag(getReverseOrder(developments)!)?.map(
                    (development: Development | DevelopmentMediacore, index: any) => (
                      <div
                        key={index}
                        className={
                          index +
                          ' mb-5 mb-lg-4 pb-lg-2 px-lg-3 ' +
                          (columns
                            ? ` col-lg-${columns}`
                            : checkTag(getReverseOrder(developments!)!)?.length === 1
                            ? 'col-lg-12 ' //Si es uno solo, 100%
                            : checkTag(getReverseOrder(developments)!)?.length < 9 &&
                              index === 0 &&
                              checkTag(getReverseOrder(developments)!)?.length % 2 === 1
                            ? 'col-lg-12 ' // Si impares menor a 9, el primero 100%
                            : checkTag(getReverseOrder(developments)!)?.length < 9
                            ? 'col-lg-6' //Si menores a 9, 50%
                            : checkTag(getReverseOrder(developments)!)?.length >= 9 &&
                              checkTag(getReverseOrder(developments)!)?.length % 3 === 1 &&
                              index === 0
                            ? 'col-lg-12' // Si es mayor o igual a 9, y sobra 1, 100% el primero
                            : checkTag(getReverseOrder(developments)!)?.length >= 9 &&
                              checkTag(getReverseOrder(developments)!)?.length % 3 === 2 &&
                              (index === 0 || index === 1)
                            ? 'col-lg-6' // Si son 9 o mas, y sobran 2, los primeros 2, 50%
                            : 'col-lg-4') // Si son 9 o mas, 33,3%
                        }
                      >
                        <Card
                          key={index}
                          development={development}
                          global_data={global_data}
                        />
                      </div>
                    ),
                  )
                ) : (
                  <h4 className="text-center">
                    No hay emprendimientos{' '}
                    {filter !== 'VER TODOS' &&
                      buttons.find((element) => element.name === filter)?.name?.toLowerCase()}
                  </h4>
                )
              ) : (
                [1, 2, 3].map((index) => (
                  <Col
                    xs={12}
                    lg={4}
                    key={index}
                  >
                    <Card
                      skeleton={true}
                      global_data={global_data}
                    />
                  </Col>
                ))
              )}
            </Row>
          </Container>
        }
      </div>
    </section>
  )
}
export default Developments_1
